// 9fbef606107a605d69c0edbcd8029e5d
import theme from '@tcp/core/styles/themes/TCP';

const { breakpoints } = theme;

const BUNDLE_TRACKER_CONSTANTS = {
  TOGGLE_TRACKER: 'TOGGLE_TRACKER',
  TRACKER_STATE: 'TRACKER_STATE',
  SET_BUNDLE_DATA: 'SET_BUNDLE_DATA',
};

export const carouselSetting = {
  carouselOptions: {
    autoplay: false,
    arrows: true,
    fade: false,
    speed: 500,
    dots: false,
    swipe: true,
    slidesToShow: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: parseInt(breakpoints.medium, 10) - 1,
        settings: {
          autoplay: false,
        },
      },
    ],
  },
  carouselConfig: {
    arrow: 'small',
  },
};

export default BUNDLE_TRACKER_CONSTANTS;
